import React from 'react';
import PropTypes from 'prop-types';
import Toast from './Toast';
import './ToastContainer.css';

/**
 * ToastContainer Component
 * Manages and displays multiple toast notifications
 */
const ToastContainer = ({toasts, onRemoveToast}) => {
  return (
    <div className="toast-container">
      {toasts.map(toast => (
        <Toast
          duration={toast.duration}
          key={toast.id}
          message={toast.message}
          onClose={() => onRemoveToast(toast.id)}
          type={toast.type}
        />
      ))}
    </div>
  );
};

ToastContainer.propTypes = {
  onRemoveToast: PropTypes.func.isRequired,
  toasts: PropTypes.arrayOf(
    PropTypes.shape({
      duration: PropTypes.number,
      id: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired,
      type: PropTypes.oneOf(['success', 'error', 'warning', 'info'])
    })
  ).isRequired
};

export default ToastContainer;
